import React, { useEffect } from 'react';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ErrorOutline } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

function ModalErrorResponse({ open, toggleModal, modalText, listErrors }) {
  const { t } = useTranslation();
  
  useEffect(() => {
  }, [toggleModal]);

  return (
    <Dialog onClose={() => toggleModal(false)} open={open}>
      <IconButton
        aria-label="close"
        onClick={() => toggleModal(false)}
        sx={{
          position: 'absolute',
          right: '8px',
          top: '8px',
        }}>
        <CloseIcon />
      </IconButton>
      <Box p={3}>
        <DialogTitle className="text-center h-40vh overflow-hidden">
          <Stack spacing={2} direction={'row'} justifyContent="center" alignItems="center" p={2}>
            <ErrorOutline sx={{ color: "#e91e63" }} fontSize='large'/>
            <Typography className='fw-bold text-danger'>{modalText} </Typography>
          </Stack>
        </DialogTitle>
          {listErrors?.length > 0 &&
            <DialogContent 
              sx={{
                display: 'flex',
                flexDirection: 'column',
                maxHeight:'40vh',
                overflowY: 'auto',
                color:"red",
                borderTop: '2px solid #e9ecef',
              }}
            >
              {listErrors.map((asset, i) =>
                <>
                  <Typography variant="subtitle2" sx={{textAlign: 'left'}} pt={1}>
                    {asset.pk}:
                  </Typography>
                    {asset.errors?.map(error => {                  
                      let errorMsg = (t(`stepByStep.commonErrors.${error.message}`));
                      return (
                        <>
                          <Typography variant="caption" sx={{textAlign: 'left', paddingLeft: 2}}>
                            - {errorMsg.includes('stepByStep.commonErrors') ? t(`stepByStep.commonErrors.unexpectedError`) : errorMsg}
                          </Typography>
                        </>
                      )
                    })}
                </>
              )}
            </DialogContent>
          }
        </Box>
    </Dialog>
  );
}

export default ModalErrorResponse;
